<ul class="layout-menu mt-3">
    <fb-tabpanel-button *ngIf="_auth.userValue" [configuration]="tabPanelButtonConfiguration"></fb-tabpanel-button>
    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>


<p-toast [breakpoints]="{ '920px': { width: '90%', right: '0', left: '10px' } }" position="bottom-right" key="br" />

